import * as React from 'react';
import Grid from '@mui/material/Grid';

type DigitalStylingThumbnailSkeletonProps = {
    // ...
};

export function DigitalStylingThumbnailSkeleton({}: DigitalStylingThumbnailSkeletonProps) {
    return (
        <Grid item xs={12} sm={6} md={4} lg={3}>
            <div
                className="thumbnail thumbnail-custom"
                style={{
                    display: 'flex',
                    maxHeight: '237px'
                }}
            >
                <div className="skeleton" />
            </div>
        </Grid>
    );
}
